import { curry } from "ramda";

export const intersect = curry(<T>(types: T[], otherTypes: T[]): boolean => {
  return types.some((type) => otherTypes.includes(type));
});
